export default __webpack_public_path__ + "static/media/HelveticaNeueBold.3fd49460.woff2";